import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['shadow', 0.24],
        ['woodpile', 0.76],
      ],
      d: 'M1,-3h1v0.5h-1zM0,-2.5h1v0.5h-1zM1.5,-2.5h0.5v0.5h-0.5zM0.5,-2h1v0.5h-1zM-0.5,-1.5h1.5v0.5h-1.5zM1.5,-1h1v0.5h-1zM0.5,-0.5h2v0.5h-2zM0,0h1v0.5h-1z',
    },
    {
      paint: [
        ['sail', 0.22],
        ['woodpile', 0.78],
      ],
      d: 'M0,-3.5h2v0.5h-2zM-0.5,-3h1v0.5h-1zM-1,-2.5h0.5v0.5h-0.5zM-0.5,-2h0.5v0.5h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM-1.5,-1.5h1v0.5h-1zM1.5,-1.5h1v0.5h-1zM-2.5,-1h1.5v0.5h-1.5zM-0.5,-1h1.5v0.5h-1.5zM-2,-0.5h0.5v0.5h-0.5zM-1,-0.5h0.5v0.5h-0.5zM-0.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M-1,-3h0.5v0.5h-0.5zM-1.5,-2.5h0.5v0.5h-0.5zM-0.5,-2.5h0.5v0.5h-0.5zM-2,-2h1.5v0.5h-1.5zM-2,-1.5h0.5v0.5h-0.5zM-3,-1h0.5v0.5h-0.5zM-3,-0.5h1v0.5h-1zM-0.5,-0.5h0.5v0.5h-0.5zM-1.5,0h1v0.5h-1z',
    },
    {
      paint: 'woodpile',
      d: 'M0.5,-3h0.5v0.5h-0.5zM1,-2.5h0.5v0.5h-0.5zM0,-2h0.5v0.5h-0.5zM1,-1.5h0.5v1h-0.5zM-1,-1h0.5v0.5h-0.5zM-1.5,-0.5h0.5v0.5h-0.5zM0,-0.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 61,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
